module.exports = __webpack_public_path__ + "img/greetix.529b4c03.png";